var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useForm } from "react-hook-form";
import { useKushkiJsContext } from "../../../context/useKushkiJsContext";
import { useCheckoutContext, } from "../../../context/useCheckoutContext";
import React, { useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { PaymentMethodsEnum } from "../../../shared/constants/PaymentMethodEnum";
import { CheckoutCardThreeDSecureEnum } from "../../../shared/constants/CheckoutCardThreeDSecureEnum";
import { checkTermsAndConditions, validateCardNumber, } from "../../../utils/utils";
import { Translate as T } from "react-localize-redux";
export var CardType = {
    CREDIT: "credit",
    DEBIT: "debit",
};
export var useCheckoutCardDynamicState = function () {
    var form = useForm({
        shouldUnregister: false,
        reValidateMode: "onBlur",
    });
    var _a = useKushkiJsContext(), requestCardAsyncToken = _a.requestCardAsyncToken, requestCardToken = _a.requestCardToken, requestBin = _a.requestBin, requestDeferred = _a.requestDeferred, requestBrandsLogos = _a.requestBrandsLogos, requestSecureServiceValidation = _a.requestSecureServiceValidation, request3DS = _a.request3DS;
    var _b = useCheckoutContext(), handlers = _b.handlers, amount = _b.amount, kpayEnable = _b.kpayEnable, currency = _b.currency, emailKpay = _b.emailKpay, termsAndConditions = _b.termsAndConditions;
    var _c = useState(""), currentBin = _c[0], setCurrentBin = _c[1];
    var _d = useState(""), cardBrand = _d[0], setCardBrand = _d[1];
    var _e = useState(false), hasDeferred = _e[0], setHasDeferred = _e[1];
    var _f = useState(false), isDeferredActive = _f[0], setIsDeferredActive = _f[1];
    var _g = useState(false), isDynamic = _g[0], setIsDynamic = _g[1];
    var _h = useState([]), months = _h[0], setMonths = _h[1];
    var _j = useState([]), monthsOfGrace = _j[0], setMonthsOfGrace = _j[1];
    var _k = useState([]), typesDeferred = _k[0], setTypeDeferred = _k[1];
    var _l = useState([]), deferredInfo = _l[0], setDeferredInfo = _l[1];
    var _m = useState([]), brands = _m[0], setBrands = _m[1];
    var _o = useState(false), acceptTerms = _o[0], setAcceptTerms = _o[1];
    var _p = useState(false), openTerms = _p[0], setOpenTerms = _p[1];
    var _q = useState(""), secureServiceId = _q[0], setSecureServiceId = _q[1];
    var _r = useState(""), optValue3ds = _r[0], setOptValue3ds = _r[1];
    var _s = useState({}), updateOtpState = _s[0], setUpdateOtpState = _s[1];
    var _t = useState(""), cardType = _t[0], setCardType = _t[1];
    var _u = useState({
        months: "",
        monthsOfGrace: "",
        typeDeferred: "",
    }), deferredCurrentValues = _u[0], setDeferredCurrentValues = _u[1];
    var handleOpenTerms = function (open) {
        setOpenTerms(open);
    };
    var reduceOptions = function (deferred, kind) {
        return deferred.reduce(function (acc, curr) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a["" + curr.type] = __spreadArrays(curr[kind]).map(function (m) { return ({
                label: m,
                value: m,
            }); }), _a)));
        }, {});
    };
    var getBrands = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cardTypeLogo, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handlers.setCheckoutLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, requestBrandsLogos()];
                case 2:
                    cardTypeLogo = _a.sent();
                    setBrands(cardTypeLogo);
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 5];
                case 4:
                    handlers.setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getBrands();
    }, []);
    var getBin = function (newBin) { return __awaiter(void 0, void 0, void 0, function () {
        var cardInfo_1, brand, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, requestBin({ bin: newBin })];
                case 1:
                    cardInfo_1 = _a.sent();
                    brand = brands.find(function (_a) {
                        var brand = _a.brand;
                        return brand.toLocaleLowerCase() === cardInfo_1.brand.toLocaleLowerCase();
                    });
                    handlers.closeErrorNotification();
                    handlers.setCardBrandContext(cardInfo_1.brand);
                    setCardType(cardInfo_1.cardType);
                    setCardBrand((brand === null || brand === void 0 ? void 0 : brand.url) || cardInfo_1.brand);
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    setCardType("");
                    setCardBrand("");
                    handlers.showErrorNotification(e_2);
                    console.error(e_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getDeferred = function (newBin) { return __awaiter(void 0, void 0, void 0, function () {
        var cardInfo, typeDeferred, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, requestDeferred({
                            bin: newBin,
                        })];
                case 1:
                    cardInfo = _a.sent();
                    if (isEmpty(cardInfo)) {
                        setHasDeferred(false);
                    }
                    else {
                        setHasDeferred(true);
                        setDeferredInfo(cardInfo);
                        typeDeferred = cardInfo.map(function (opt) { return ({
                            label: opt.name,
                            value: opt.type,
                        }); });
                        setIsDynamic(true);
                        setTypeDeferred(typeDeferred);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    console.error(e_3);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSetFields = function (kind, value) {
        var _a;
        var _b;
        if (kind === "card") {
            var cardNumber = String(form.getValues("cardNumber")).replace(/\s/g, "");
            var newBin = cardNumber.substring(0, 8);
            if (cardNumber.trim().length >= 8 && currentBin !== newBin) {
                setCurrentBin(newBin);
                getBin(newBin);
                getDeferred(newBin);
            }
            else if (cardNumber.trim().length < 8) {
                setHasDeferred(false);
                setIsDeferredActive(false);
                setCardBrand("");
            }
        }
        else if (kind === "activeQuote") {
            setIsDeferredActive(!isDeferredActive);
            if (((_b = deferredInfo[0]) === null || _b === void 0 ? void 0 : _b.type) === "all") {
                handleSetFields("typeDeferred", "all");
            }
            if (isDeferredActive)
                handleSetFields("months", "");
            return;
        }
        else if (kind === "months" ||
            kind === "monthsOfGrace" ||
            kind === "typeDeferred") {
            if (kind === "typeDeferred") {
                setHasDeferred(true);
                var month = reduceOptions(deferredInfo, "months");
                var monthOfGrace = reduceOptions(deferredInfo, "monthsOfGrace");
                setMonths(month[value]);
                setMonthsOfGrace(monthOfGrace[value]);
                setDeferredCurrentValues({
                    months: month[value][0].value,
                    monthsOfGrace: !isEmpty(monthOfGrace[value])
                        ? monthOfGrace[value][0].value
                        : "",
                    typeDeferred: value,
                });
                return;
            }
            setDeferredCurrentValues(__assign(__assign({}, deferredCurrentValues), (_a = {}, _a[kind] = value, _a)));
        }
    };
    var handleTermsAcceptance = function (event) {
        setAcceptTerms(event.target.checked);
    };
    var handleCardBrand = function (event) {
        var cardNumber = event.target.value.replace(/ /g, "");
        validateCard(cardNumber);
    };
    var handleCardBrandPaste = function (event) {
        var cardNumber = event.clipboardData
            .getData("Text")
            .replace(/ /g, "");
        validateCard(cardNumber);
    };
    var validateCard = function (cardNumber) {
        if (validateCardNumber(cardNumber))
            handleSetFields("card");
    };
    var setCheckOutToken = function (tokenResponse) {
        var checkoutToken = {
            paymentMethod: PaymentMethodsEnum.CARD,
            secureId: tokenResponse.secureId,
            secureService: tokenResponse.secureService,
            token: tokenResponse.token,
        };
        if (isDeferredActive) {
            checkoutToken.deferredConfig = {
                deferredType: deferredCurrentValues.typeDeferred,
                graceMonths: deferredCurrentValues.monthsOfGrace,
                months: +deferredCurrentValues.months,
            };
        }
        handlers.setCheckoutToken(checkoutToken);
    };
    var isKushkiOtpValid = function (secureOtpResponse) {
        return ("message" in secureOtpResponse &&
            secureOtpResponse.message ===
                CheckoutCardThreeDSecureEnum.SECURE_OTP_RESPONSE_OK &&
            secureOtpResponse.code === CheckoutCardThreeDSecureEnum.OTP000);
    };
    var is3dsValid = function (secureOtpResponse) {
        return ("message" in secureOtpResponse &&
            secureOtpResponse.message === CheckoutCardThreeDSecureEnum["3DS000"] &&
            secureOtpResponse.code ===
                CheckoutCardThreeDSecureEnum.SECURE_OTP_RESPONSE_OK);
    };
    var validateOtp = function (secureOtpRequest, tokenResponse) { return __awaiter(void 0, void 0, void 0, function () {
        var secureServiceValidationResponse, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, requestSecureServiceValidation(__assign({}, secureOtpRequest))];
                case 1:
                    secureServiceValidationResponse = _a.sent();
                    if (isKushkiOtpValid(secureServiceValidationResponse) ||
                        is3dsValid(secureServiceValidationResponse)) {
                        setUpdateOtpState({ isValid: true });
                        setCheckOutToken(tokenResponse);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    console.error("Error on SecureServiceValidation request", e_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var validatePayment = function (secureServiceId, tokenResponse) { return __awaiter(void 0, void 0, void 0, function () {
        var otp_request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    otp_request = {
                        otpValue: "",
                        secureServiceId: secureServiceId,
                    };
                    return [4 /*yield*/, validateOtp(otp_request, tokenResponse)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var checkHasSecure3D = function (tokenResponse) {
        if (!isEmpty(get(tokenResponse, "secureId")) &&
            !isEmpty(get(tokenResponse, "security")) &&
            get(tokenResponse, "security.authRequired") &&
            get(tokenResponse, "secureService") ===
                CheckoutCardThreeDSecureEnum.THREEDSECURE) {
            setSecureServiceId(get(tokenResponse, "secureId", ""));
            setOptValue3ds("155");
            return true;
        }
        return false;
    };
    var threeDSecureFlow = function (tokenResponse) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!checkHasSecure3D(tokenResponse)) return [3 /*break*/, 2];
                    request3DS({
                        secureId: tokenResponse.secureId,
                        security: __assign(__assign({}, tokenResponse.security), { authRequired: tokenResponse.security.authRequired }),
                    });
                    return [4 /*yield*/, validatePayment(get(tokenResponse, "secureId", ""), tokenResponse)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setCheckOutToken(tokenResponse);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var currentEmail, expDate, isDeferred, deferredMonths, tokenResponse, e_5, urlParams, tokenResponse, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    currentEmail = emailKpay ? emailKpay : formData.email;
                    if (!checkTermsAndConditions(formData.terms, termsAndConditions)) return [3 /*break*/, 9];
                    handlers.setTokenRequestLoading(true);
                    if (!(cardType === CardType.CREDIT)) return [3 /*break*/, 6];
                    if (kpayEnable && formData.email)
                        handlers.setEmailKpay(formData.email);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    expDate = formData.expDate.split("/");
                    isDeferred = deferredCurrentValues.months !== "";
                    deferredMonths = deferredCurrentValues.months !== ""
                        ? +deferredCurrentValues.months
                        : 0;
                    return [4 /*yield*/, requestCardToken({
                            amount: amount.total,
                            card: {
                                cvc: formData.cvc,
                                expiryMonth: expDate[0],
                                expiryYear: expDate[1],
                                name: formData.name,
                                number: formData.cardNumber.replace(/ /g, ""),
                            },
                            currency: amount.currency,
                            isDeferred: isDeferred,
                            months: deferredMonths,
                        })];
                case 2:
                    tokenResponse = _a.sent();
                    handlers.closeErrorNotification();
                    threeDSecureFlow(tokenResponse);
                    return [3 /*break*/, 5];
                case 3:
                    e_5 = _a.sent();
                    handlers.showErrorNotification(e_5);
                    console.error(e_5);
                    return [3 /*break*/, 5];
                case 4:
                    handlers.setTokenRequestLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 9];
                case 6:
                    _a.trys.push([6, 8, , 9]);
                    urlParams = {
                        currency: currency,
                        email: currentEmail,
                        paymentMethod: PaymentMethodsEnum.CARD_ASYNC,
                        totalValue: amount.total.toString(),
                    };
                    return [4 /*yield*/, requestCardAsyncToken({
                            currency: amount.currency,
                            email: currentEmail,
                            returnUrl: handlers.buildCallbackUrl(urlParams),
                            totalAmount: amount.total,
                        })];
                case 7:
                    tokenResponse = _a.sent();
                    handlers.closeErrorNotification();
                    handlers.setCheckoutToken({
                        contactDetails: {
                            email: currentEmail,
                        },
                        paymentMethod: PaymentMethodsEnum.CARD_ASYNC,
                        token: tokenResponse.token,
                    });
                    return [3 /*break*/, 9];
                case 8:
                    e_6 = _a.sent();
                    handlers.showErrorNotification(e_6);
                    console.error(e_6);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var isValidDate = function (expDate) {
        var monthDate = function (expDate) { return Number(expDate.split("/")[0]); };
        var yearDate = function (expDate) {
            return Number("20".concat(expDate.split("/")[1]));
        };
        return new Date() > new Date(yearDate(expDate), monthDate(expDate))
            ? (React.createElement(T, { id: "form.expirationDateIncorrect" }))
            : true;
    };
    return {
        acceptTerms: acceptTerms,
        brands: brands,
        cardBrand: cardBrand,
        deferredCurrentValues: deferredCurrentValues,
        deferredOptions: {
            hasDeferred: hasDeferred,
            isActive: isDeferredActive,
            isDynamic: isDynamic,
            months: months,
            monthsOfGrace: monthsOfGrace,
            typesDeferred: typesDeferred,
        },
        form: form,
        handler: {
            getBin: getBin,
            handleCardBrand: handleCardBrand,
            handleCardBrandPaste: handleCardBrandPaste,
            handleOpenTerms: handleOpenTerms,
            handleSetFields: handleSetFields,
            handleSetKpayEnable: handlers.setKpayEnable,
            handleSubmit: handleSubmit,
            handleTermsAcceptance: handleTermsAcceptance,
        },
        isValidDate: isValidDate,
        kpayEnable: kpayEnable,
        openTerms: openTerms,
        optValue3ds: optValue3ds,
        secureServiceId: secureServiceId,
        updateOtpState: updateOtpState,
        cardType: cardType,
    };
};
